import { Button, Modal } from "~components";
import { Css } from "~generated/css";
import { queryResult } from "~utils";
import { useDebugModal_LoadQuery } from "./DebugModal.generated";

type DebugModalProps = {
  checkoutConfigId: string;
  onClose: () => void;
};

export function DebugModal({ checkoutConfigId, onClose }: DebugModalProps) {
  const query = useDebugModal_LoadQuery({ variables: { id: checkoutConfigId } });

  return (
    <Modal isOpen close={onClose} title="Config Details" size={{ width: "560px", height: "auto" }}>
      {queryResult(query, ({ checkoutConfig: config }) => {
        const { productOffering: pof, structure } = config;

        return (
          <div css={Css.df.fdc.px3.pt2.pb4.$}>
            <DebugLinkRow name="Pricing Trace" url={config.pricingTraceUrl?.url} />
            <DebugLinkRow label="Structure" name={structure.name} url={structure.blueprintUrl.url} />
            {pof && (
              <>
                <DebugLinkRow label="Product Offering" name={pof.name} url={pof.blueprintUrl.url} />
                <div css={Css.pl3.df.fdc.$}>
                  <DebugLinkRow
                    label="Plan Package"
                    name={pof.planPackage.name}
                    url={pof.planPackage.blueprintUrl.url}
                  />
                  <DebugLinkRow
                    label="Interior Design Package"
                    name={pof.interiorDesignPackage.name}
                    url={pof.interiorDesignPackage.blueprintUrl.url}
                  />
                  <DebugLinkRow
                    label="Exterior Design Package"
                    name={pof.exteriorDesignPackage.name}
                    url={pof.exteriorDesignPackage.blueprintUrl.url}
                  />
                </div>
              </>
            )}
          </div>
        );
      })}
    </Modal>
  );
}

type DebugLinkRowProps = { label?: string; name?: string; url: string | undefined };

function DebugLinkRow({ label, name, url }: DebugLinkRowProps) {
  if (!url) return null;
  return (
    <div css={Css.df.fdc.py1.bb.bcGray200.$}>
      <span css={Css.t12.gray.$}>{label}</span>
      <Button variant="link" href={url} openInNewTab xss={Css.jcfs.t14.fw500.pl0.$}>
        {name ?? label}
      </Button>
    </div>
  );
}
